if (!customElements.get("td-tabs")) {
  class TdTabs extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.TABS_WRAPPER = this.querySelector('[data-tabs-wrapper]')
      this.TRIGGERS = this.querySelectorAll('[data-id]');
      this.TAB_SCROLL_LEFT = this.querySelector('[data-scroll-tab-left]');
      this.TAB_SCROLL_RIGHT = this.querySelector('[data-scroll-tab-right]');
      this.ANIMATED_UNDERLINE = this.querySelector('[data-animated-underline]');
      this.activeTab = this.querySelector('.__tabs-tab.td-active');
      this.activeTabContent = document.querySelector(`#${this.activeTab?.dataset?.id}`);
      if (!this.ANIMATED_UNDERLINE || !this.activeTab || !this.activeTabContent) {
        return
      }

      this.setActiveTab();
      this.setActiveTabNavArrows();
      this.attachListeners();
    }

    attachListeners() {
      this.TRIGGERS.forEach((trigger) => {
        // Handle mouse clicks
        trigger.addEventListener('click', () => {
          this.activeTab = trigger;
          this.setActiveTab();
        });

        // Handle keyboard activation (Enter/Space)
        trigger.addEventListener('keydown', (event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            this.activeTab = trigger;
            this.setActiveTab();
          }
        });
      });
      this.TABS_WRAPPER.addEventListener('scroll', () => {
        this.setActiveTabNavArrows();
      })
      this.TAB_SCROLL_LEFT.addEventListener('click', () => {
        this.scrollTabs(-100, 'left');
      })
      this.TAB_SCROLL_RIGHT.addEventListener('click', () => {
        this.scrollTabs(100, 'right');
      })
      window.addEventListener('resize', () => {
        this.setActiveTab();
        this.setActiveTabNavArrows();
      })
      window.addEventListener('td:section-switcher-changed', () => {
        this.setActiveTab();
      })
    }

    setActiveTab() {
      this.activeTabContent.classList.remove('td-active');
      this.activeTabContent = document.querySelector(`#${this.activeTab?.dataset?.id}`);
      this.ANIMATED_UNDERLINE.style.cssText = `
        left: ${this.activeTab.offsetLeft}px;
        width: ${this.activeTab.offsetWidth - 0.5}px;
      `;
      this.activeTabContent.classList.add('td-active');

      // Update aria-selected attributes
      this.TRIGGERS.forEach(trigger => {
        trigger.setAttribute('aria-selected', 'false');
      });
      this.activeTab.setAttribute('aria-selected', 'true');

      // Announce tab change to screen readers
      const announcement = document.querySelector('[data-tab-announcement]');
      if (announcement) {
        const tabName = this.activeTab.textContent.trim() || 'tab';
        announcement.innerHTML = `${tabName} tab selected`;
      }
    }

    setActiveTabNavArrows() {
      if (!this.TAB_SCROLL_LEFT || !this.TAB_SCROLL_RIGHT) {
        return
      }
      if (this.isScrollable()) {
        if (this.isScrolledLeft()) {
          this.TAB_SCROLL_LEFT.classList.remove('td-active');
        } else {
          this.TAB_SCROLL_LEFT.classList.add('td-active');
        }
        
        if (this.isScrolledRight()) {
          this.TAB_SCROLL_RIGHT.classList.remove('td-active');
        } else {
          this.TAB_SCROLL_RIGHT.classList.add('td-active');
        }
      } else {
        this.TAB_SCROLL_LEFT.classList.remove('td-active');
        this.TAB_SCROLL_RIGHT.classList.remove('td-active');
      }
    }

    isScrollable() {
      return this.TABS_WRAPPER.scrollWidth > this.TABS_WRAPPER.clientWidth;
    }

    isScrolledLeft() {
      return this.TABS_WRAPPER.scrollLeft === 0;
    }

    isScrolledRight() {
      const tolerance = 1;
      return Math.abs(this.TABS_WRAPPER.scrollLeft + this.TABS_WRAPPER.clientWidth - this.TABS_WRAPPER.scrollWidth) <= tolerance;
    }

    scrollTabs(scrollAmount, direction) {
      const currentScrollPosition = this.TABS_WRAPPER.scrollLeft + scrollAmount;
      if (currentScrollPosition <= 0) {
        this.TABS_WRAPPER.scrollTo({
          left: 0,
          behavior: 'smooth'
        });
      } else if (currentScrollPosition >= (this.TABS_WRAPPER.scrollWidth - this.TABS_WRAPPER.clientWidth)) {
        this.TABS_WRAPPER.scrollTo({
          left: this.TABS_WRAPPER.scrollWidth - this.TABS_WRAPPER.scrollLeft,
          behavior: 'smooth'
        });
      } else {
        this.TABS_WRAPPER.scrollTo({
          left: currentScrollPosition,
          behavior: 'smooth'
        });
      }
    }
  }

  customElements.define("td-tabs", TdTabs);
}

// Reel Triggers Scroll Functionality
(function() {
  function initReelsScroll(container) {
    // Prevent duplicate initialization
    if (container.dataset.reelsScrollInitialized === 'true') {
      return;
    }

    const REELS_WRAPPER = container.querySelector('[data-reels-wrapper]');
    const REELS_SCROLL_LEFT = container.querySelector('[data-scroll-reels-left]');
    const REELS_SCROLL_RIGHT = container.querySelector('[data-scroll-reels-right]');

    if (!REELS_WRAPPER || !REELS_SCROLL_LEFT || !REELS_SCROLL_RIGHT) {
      return;
    }

    // Mark as initialized
    container.dataset.reelsScrollInitialized = 'true';

    function setActiveReelsNavArrows() {
      if (isScrollable()) {
        if (isScrolledLeft()) {
          REELS_SCROLL_LEFT.classList.remove('td-active');
        } else {
          REELS_SCROLL_LEFT.classList.add('td-active');
        }
        
        if (isScrolledRight()) {
          REELS_SCROLL_RIGHT.classList.remove('td-active');
        } else {
          REELS_SCROLL_RIGHT.classList.add('td-active');
        }
      } else {
        REELS_SCROLL_LEFT.classList.remove('td-active');
        REELS_SCROLL_RIGHT.classList.remove('td-active');
      }
    }

    function isScrollable() {
      return REELS_WRAPPER.scrollWidth > REELS_WRAPPER.clientWidth;
    }

    function isScrolledLeft() {
      return REELS_WRAPPER.scrollLeft === 0;
    }

    function isScrolledRight() {
      const tolerance = 1;
      return Math.abs(REELS_WRAPPER.scrollLeft + REELS_WRAPPER.clientWidth - REELS_WRAPPER.scrollWidth) <= tolerance;
    }

    function scrollReels(scrollAmount, direction) {
      const currentScrollPosition = REELS_WRAPPER.scrollLeft + scrollAmount;
      if (currentScrollPosition <= 0) {
        REELS_WRAPPER.scrollTo({
          left: 0,
          behavior: 'smooth'
        });
      } else if (currentScrollPosition >= (REELS_WRAPPER.scrollWidth - REELS_WRAPPER.clientWidth)) {
        REELS_WRAPPER.scrollTo({
          left: REELS_WRAPPER.scrollWidth - REELS_WRAPPER.scrollLeft,
          behavior: 'smooth'
        });
      } else {
        REELS_WRAPPER.scrollTo({
          left: currentScrollPosition,
          behavior: 'smooth'
        });
      }
    }

    // Initialize arrows on load
    setActiveReelsNavArrows();

    // Attach listeners
    REELS_WRAPPER.addEventListener('scroll', () => {
      setActiveReelsNavArrows();
    });

    REELS_SCROLL_LEFT.addEventListener('click', () => {
      scrollReels(-100, 'left');
    });

    REELS_SCROLL_RIGHT.addEventListener('click', () => {
      scrollReels(100, 'right');
    });

    window.addEventListener('resize', () => {
      setActiveReelsNavArrows();
    });
  }

  // Initialize all reel triggers wrappers
  function initAllReelsScroll() {
    const wrappers = document.querySelectorAll('.td-reels-triggers-wrapper');
    wrappers.forEach(initReelsScroll);
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllReelsScroll);
  } else {
    initAllReelsScroll();
  }

  // Re-initialize when new content is loaded (e.g., when tabs are switched)
  document.addEventListener('td:section-switcher-changed', () => {
    initAllReelsScroll();
  });

  // Initialize when tab content becomes active (using MutationObserver)
  function setupObserver() {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          const target = mutation.target;
          if (target.classList.contains('td-reels-tabs-content') && target.classList.contains('td-active')) {
            const wrapper = target.querySelector('.td-reels-triggers-wrapper');
            if (wrapper) {
              // Small delay to ensure DOM is updated
              setTimeout(() => {
                initReelsScroll(wrapper);
              }, 10);
            }
          }
        }
      });
    });

    // Observe all reel tabs content elements
    document.querySelectorAll('.td-reels-tabs-content').forEach((content) => {
      observer.observe(content, { attributes: true, attributeFilter: ['class'] });
    });
  }

  // Setup observer when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupObserver);
  } else {
    setupObserver();
  }
})();
